export type PaginationTokens = {
  pagination: {
    item?: {
      color?: string;
      backgroundColor?: string;
      fontSize?: string;
      fontWeight?: string | number;
      borderRadius?: string;
      minWidth?: string;
      height?: string;
      hoverBackgroundColor?: string;
    };
    selectedItem?: {
      backgroundColor?: string;
      color?: string;
      borderColor?: string;
      borderWidth?: string;
      borderStyle?: string;
      borderRadius?: string;
      fontWeight?: string | number;
      hoverBackgroundColor?: string;
    };
    navigation?: {
      backgroundColor?: string;
      color?: string;
      borderRadius?: string;
      size?: string;
      iconFontSize?: string;
      hoverBackgroundColor?: string;
    };
    ellipsis?: {
      color?: string;
    };
    perPageSelect?: {
      borderRadius?: string;
      backgroundColor?: string;
      borderColor?: string;
      borderWidth?: string;
      color?: string;
      fontSize?: string;
      fontWeight?: string;
    };
  };
};

export const usePaginationTokens = (): PaginationTokens => {
  // Returns empty since we use MUI behavior as default
  const comp: PaginationTokens = {
    pagination: {},
  };
  return comp;
};
